import { createAction, props } from '@ngrx/store';
import { INote } from '@care-portals/api-interfaces';

export const loadNotes = createAction(
  '[Note] Load Notes',
  props<{ filters: any }>()
);

export const loadNotesSuccess = createAction(
  '[Note] Load Notes Success',
  props<{ notes: INote[] }>()
);

export const loadNotesFailure = createAction(
  '[Note] Load Notes Failure',
  props<{ error: any }>()
);

export const loadAppointmentNotes = createAction(
  '[Note] Load Appointment Notes',
  props<{ appointmentId: string }>()
);

export const loadAppointmentNotesSuccess = createAction(
  '[Note] Load Appointment Notes Success',
  props<{ notes: INote[] }>()
);

export const loadAppointmentNotesFailure = createAction(
  '[Note] Load Appointment Notes Failure',
  props<{ error: any }>()
);

export const upsertNote = createAction(
  '[Note] Create Note',
  props<{ note: Partial<INote>; updateAppointmentNotes?: boolean }>()
);

export const upsertNoteSuccess = createAction(
  '[Note] Create Note Success',
  props<{ note: INote; updateAppointmentNotes?: boolean }>()
);

export const upsertNoteFailure = createAction(
  '[Note] Create Note Failure',
  props<{ error: any }>()
);

export const clearAppointmentNotes = createAction(
  '[Note] Clear Appointment Notes'
);
